import { QueryClient, QueryClientProvider } from 'react-query'
import NatsProvider from '.'
import { WithChildren } from '@/root/types/utilities'

const NatsProviderWrapper = ({
  children,
  platform,
  authorization,
}: WithChildren<{ platform?: string; authorization?: string }>) => {
  return (
    <div>
      <QueryClientProvider
        client={
          new QueryClient({
            defaultOptions: {
              queries: {
                refetchOnWindowFocus: false,
              },
            },
          })
        }
      >
        <NatsProvider platform={platform} authorization={authorization}>
          {children}
        </NatsProvider>
      </QueryClientProvider>
    </div>
  )
}

export default NatsProviderWrapper
